import { TestimonialType } from "@/sections/Testimonials";
import CustomImage from "../CustomImage";
import Text from "../Text";
import { transformText } from "@/utils/transformText";
import GradientLightText from "../GradientLightText";

type TestimonialCardProps = {
  content: TestimonialType;
  hideShadow?: boolean;
};

const TestimonilaCard = ({ content, hideShadow }: TestimonialCardProps) => {
  return (
    <div className="testimonial-card">
      <CustomImage
        alt={content.image.alt}
        src={content.image.src.desktop}
        srcTablet={content.image.src.tablet}
        srcMobile={content.image.src.mobile}
        className="testimonial-card__image"
      />
      <div className="testimonial-card__holder">
        <Text element="p" elementStyle="body">
          {content.text}
        </Text>
        <Text element="p" elementStyle="body">
          {transformText(content.name, {
            gradient: (chunk) => (
              <GradientLightText
                element="span"
                classNames={hideShadow ? "light-gradient--no-shadow" : ""}
              >
                {chunk}
              </GradientLightText>
            ),
          })}
        </Text>
      </div>
    </div>
  );
};

export default TestimonilaCard;
